'use strict';

module.exports = require('./lib/ConfirmLink.js');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-confirm-dialog/index.js
 ** module id = 213
 ** module chunks = 0
 **/